import selector, {identitySelector} from 'utils/selector'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {Optional} from 'data/types'
import {Observable, Observer} from 'rxjs'
import APIService from './APIService'

function getFirebaseConfig(): any {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'development':
      return {
        apiKey: 'AIzaSyAKmCHofj30VK6heFx4WAliFaVW5_3CxYs',
        authDomain: 'iterationx-dev.firebaseapp.com',
        databaseURL: 'https://iterationx-dev.firebaseio.com',
        projectId: 'iterationx-dev',
        storageBucket: 'iterationx-dev.appspot.com',
        messagingSenderId: '235310222088',
        appId: '1:235310222088:web:70f79b89a9acf925edbabd',
        measurementId: 'G-3ZXTXJM4S2',
      }
    case 'production':
      return {
        apiKey: 'AIzaSyDqMT1XdsW9T9Hx4MZmJ-YuSRrtzy6zTVE',
        authDomain: 'iterationx-prod.firebaseapp.com',
        databaseURL: 'https://iterationx-prod.firebaseio.com',
        projectId: 'iterationx-prod',
        storageBucket: 'iterationx-prod.appspot.com',
        messagingSenderId: '154126895154',
        appId: '1:154126895154:web:6714341671073dc008142b',
        measurementId: 'G-XFJ326PK1P',
      }
  }
}

firebase.initializeApp(getFirebaseConfig())

export default class RealtimeService {
  private loggedIn$: Optional<Observable<boolean>>

  private getLoggedInObservable = () => {
    if (this.loggedIn$ != null) {
      return this.loggedIn$!
    }

    const o$: Observable<boolean> = Observable.defer(async () => {
      if (firebase.auth().currentUser != null) {
        return true
      }
      const response = await APIService.getRealtimeAuthToken()
      if (!response.ok) {
        return false
      }

      await firebase.auth().setPersistence('local')
      await firebase.auth().signInWithCustomToken(response.body.token)

      return true
    })
    this.loggedIn$ = o$.shareReplay(1)
    return this.loggedIn$!
  }

  public observe = <T = any>(path: string) => {
    const ref = firebase.database().ref(path)
    const observable = this.getLoggedInObservable().flatMap(() => {
      return Observable.create((observer: Observer<T>) => {
        ref.on('value', (snapshot) => {
          observer.next(snapshot.val())
        })
        return () => {
          ref.off()
        }
      })
    }) as Observable<T>
    return observable.filter((x) => x != null)
  }
}

export const realtimeServiceSelector = selector(identitySelector<string>(), () => new RealtimeService())
